import React from 'react'
import styled from 'styled-components'
import './ProjectsData.css'
import Button from '../Button/Button'
import { Link } from 'react-router-dom'

const ProjectsData = ({ projectsData }) => {

    const [project] = projectsData
    const { name, id, head } = project

    return (
        <Abt>
            <div>
                <h1>{name}</h1>
            </div>
            <Parent>
                <small className="icon-scroll"></small>
                <Child>
                    <h1>{name}</h1>
                </Child>
                <Child>
                    <p>{head}</p>
                </Child>
            </Parent>
            <Parent>
                <Wrapper>
                    <img src={`/images/${id}.1.png`} alt="" className="tablet" />
                    <img src={`/images/${id}.png`} alt="" className="pc" />
                    {/* <img src={`/images/${id}.png`} alt="" className="mobile" /> */}
                </Wrapper>
            </Parent>
            <Parent style={{ flexDirection: "column" }}>
                <Link to="/contact">
                    <Button text="Contact" icon="link" />
                </Link>
                <a href="https://www.linkedin.com/in/mukul-rajpoot-262610/">
                    <Button text='LinkedIn' icon='linkedin' />
                </a>
            </Parent>
        </Abt>
    )
}

const Abt = styled.div`
    position: relative;
    width: 100%;
    min-height: 100vh;
    padding-top: 10vh;

    & > div {
        position: absolute;
        z-index: -1;
        padding-left: 10rem;
        top: 10%;

        @media (max-width: 768px) {
            padding-left: 5rem;
            }

        & > h1 {
            font-weight: 500;
            font-size: 15rem;
            line-height: 13rem;
            color: white;
            -webkit-text-stroke-width: 1px;
            -webkit-text-stroke-color: rgba(0,0,0,0.5);

            @media (max-width: 768px) {
                font-size: 10rem;
            }
        }
    }
`;

const Parent = styled.section`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
    padding: 5rem 0;

    & > .icon-scroll {
        position: absolute;
        top: -6%;
        right: 2%;
        z-index: 1;
    }
    & > a {
        text-decoration: none;
    }

    & > h1 {
        font-size: 3rem;
        margin: 5rem 0;
        max-width: 50%;
        text-align: center;
    }

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

const Child = styled.section`
    display: flex;
    align-items: center;
    width: 50%;
    padding: 0 5rem;

    @media (max-width: 768px) {
        width: 100%;
    }

    & > h1 {
        font-size: 6rem;
        margin: 0 5rem;
    }

    & > p {
        font-size: 2.3rem;
        text-transform: capitalize;
        max-width: 90%;
    }
`;

const Wrapper = styled.div`
    width: 100%;
    min-height: 80vh;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px) {
    min-height: 40vh;
    }

    & > .pc {
        position: absolute;
        object-fit: cover;
        width: 55vw;
        border-radius: 1rem;
        box-shadow: 2px 3px 10px rgba(0,0,0,0.6);

        @media (max-width: 768px) {
            width: 45rem;
        }
    }

    & > .tablet {
        position: absolute;
        object-fit: cover;
        width: 25vw;
        bottom: -2%;
        left: 10%;
        z-index: 10;
        border-radius: 1rem;
        box-shadow: 2px 3px 10px rgba(0,0,0,0.6);
        @media (max-width: 768px) {
            width: 25rem;
        }
    }

    & > .mobile {
        position: absolute;
        object-fit: cover;
        width: 15vw;
        bottom: -2%;
        right: 10%;
        border-radius: 1rem;
        box-shadow: 2px 3px 10px rgba(0,0,0,0.6);
        @media (max-width: 768px) {
            width: 15rem;
        }
    }
`;


export default ProjectsData
